import Vue from 'vue';
import App from './App.vue';
import './assets/reset.scss';
import VueYouTubeEmbed from 'vue-youtube-embed';
import VueObserveVisibility from 'vue-observe-visibility';

Vue.config.productionTip = false;

Vue.use(VueObserveVisibility);

Vue.use(VueYouTubeEmbed);

// Vue.use(VueAnalytics, {
//   id: "UA-83609754-1",
// });

new Vue({
  render: (h) => h(App),
}).$mount('#app');
